<template>
	<div class="car-contrast">
	  	<van-row class="carMsg twoCars">
	  		<van-col class="left" span="12"><img :style="carImgstyle" :src="image1" @error="defaultPro()" /></van-col>
		  	<van-col class="right" span="12"><img :style="carImgstyle" :src="image2" @error="defaultPro()" /></van-col>
	  	</van-row>
	  	<van-row class="carMsg">
	  		<van-col class="left" span="12">
	  			<p class="name">{{car1.name}}</p>
	  			<p class="price">指导价 {{car1.price}}万</p>
	  		</van-col>
		  	<van-col class="right" span="12">
		  		<p class="name">{{car2.name}}</p>
		  		<p class="price">指导价{{car2.price}}万</p>
		  	</van-col>
	  	</van-row>
	  	<van-row class="baseInfo first">
	  		<van-col class="title" span="24"><img src="../../assets/car/border.png" />基本信息</van-col>
	  	</van-row>
	  	<div v-for="(info,index) in result" :key="index">
		  	<div class="content" v-for="(item,index) in info.children" :key="index">
	        	<div class="pox left">{{item.name}}</div>
	        	<div class="pox middle">{{item.value1}}</div>
	        	<div class="pox right">{{item.value2}}</div>
		    </div>
	    </div>
	</div>
</template>

<script>
import productDefault from '@/assets/common/preload.png';
export default {
	data() {
	    return {
	     	carImgstyle:{
		      height: (document.body.clientWidth - 92) / 2 * 0.74 + 'px',
		    },
		    result: [],
		    image1: '',
		    image2: '',
		    car1: {},
		    car2: {}
	    };
	},
	created(){
		this.$api.setToken();
//		localStorage.removeItem('_token');
	},
	methods: {
	    getInfo() {
	    	var ID1 = this.$route.query.id1;
	    	var ID2 = this.$route.query.id2;
	    	var ids = [ID1,ID2];
	    	this.$api.get("/car/index/car-model/compare",{ids:ids}).then(res => {
		        this.result = res.result;
		        this.car1 = res.models[0];
		        this.car2 = res.models[1];
		        this.car1.price = (Math.ceil(Number(this.car1.price)/100)/100).toFixed(2);
		        this.car2.price = (Math.ceil(Number(this.car2.price)/100)/100).toFixed(2);
		        this.image1 = res.models[0].image || productDefault;
		        this.image2 = res.models[1].image || productDefault;
		    });
	    },
	    defaultPro() {
		  	var img = event.srcElement;
		    img.src = productDefault;
		    img.onerror = null; //防止闪图
		}
	},
	mounted() {
		this.getInfo();
	}
};
</script>

<style lang="less">
.car-contrast {
	height: 100%;
	overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
	background: #fff;
	color: #555;
	.carMsg {
		.van-col {
			img {
				width: 100%;
			}
			.name {
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				white-space: normal;
				height: 44px;
				line-height: 22px;
				font-size: 14px;
				color: #333;
			}
			.price {
				line-height: 22px;
				color: #F2301D;
				font-size: 13px;
				margin-top: 2px;
			}
		}
		.left {
			padding: 0 30px 0 16px;
		}
		.right {
			padding: 0 16px 0 30px;
		}
	}
	.twoCars {
		padding: 12px 0 4px;
		background: url(../../assets/car/vs.png) no-repeat center center;
	}
	.baseInfo {
		font-size: 13px;
		color: #555;
		line-height: 24px;
		border-bottom: solid 1px #bbb;
		.van-col {
			padding: 0 6px;
			height: 100%;
		}
		.title {
			border: none;
			height: 49px;
			line-height: 49px;
			font-size: 18px;
			color: #333;
			img {
				width: 4px;
				margin-right: 9px;
				float: left;
				margin-top: 14px;
			}
		}
	}
	.first {
		padding: 0 16px;
	}
	.content{
    	display: table;
        width: 100%;
        min-height: 69px;
        text-align: left;
	    .pox{
	    	width: 37%;
	    	color: #555;
	    	font-size: 13px;
	    	padding: 5px 16px;
	        display: table-cell;
            min-height: 69px;
            vertical-align: middle;
			word-break: break-all;
	    }
	    .left{
			width: 26%;
			word-break: break-all;
	    	background: #F5F6F7;
	    	border: solid 1px #bbb;
	    	border-top:  none;
	    	box-sizing: border-box;
	    }
	    .middle, .right{
	    	border-right: solid 1px #bbb;
	    	border-bottom:  solid 1px #bbb;
	    	box-sizing: border-box;
	    }
	}
}

</style>
